var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheveronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39679 0.690378C5.19798 0.497088 4.87564 0.497088 4.67683 0.690377L0.604098 4.64997C0.508625 4.74279 0.454989 4.86869 0.454989 4.99996C0.454989 5.13122 0.508625 5.25712 0.604098 5.34994L4.67683 9.30953C4.87564 9.50282 5.19798 9.50282 5.39679 9.30953C5.5956 9.11624 5.5956 8.80286 5.39679 8.60957L1.68404 4.99996L5.39679 1.39034C5.5956 1.19705 5.5956 0.883667 5.39679 0.690378Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheveronLeft);
export default __webpack_public_path__ + "static/media/cheveron-left.bc72548bdb6b4be8dbbf703eca5b7688.svg";
export { ForwardRef as ReactComponent };